// extracted by mini-css-extract-plugin
module.exports = {"nfj8k47":"nfj8k47"};